import React, { Component } from 'react';
import ButtonCompactSecondary from 'components/atoms/buttons/compact/Secondary';
import IconWrapper from 'components/atoms/IconWrapper';

class ButtonIconSecondary extends Component {
    render() {
        const { children, icon, iconColor } = this.props;

        return (
            <ButtonCompactSecondary {...this.props}>
                <IconWrapper className={`icon-${icon}`} iconColor={iconColor}/>
                {children}
            </ButtonCompactSecondary>
        );
    }
}

export default ButtonIconSecondary;



// WEBPACK FOOTER //
// ./src/components/molecules/buttons/ButtonIconSecondary.js